export default __webpack_public_path__ + "static/media/n.59bc5226.svg";